import { FC, memo } from 'react';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import { OpponentVideoItem } from '../OpponentVideoItem/OpponentVideoItem';

interface IGridLayoutListProps {
  opponentsKeys: ProviderUid[];
  avatarType: AvatarTypes;
}

export const GridLayoutList: FC<IGridLayoutListProps> = memo(({ opponentsKeys, avatarType }) => {
  return (
    <>
      {opponentsKeys.map((uid) => (
        <OpponentVideoItem
          key={uid}
          opponentUid={uid}
          avatarType={avatarType}
        />
      ))}
    </>
  );
});
